import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/newsletters/$issueNumber` — an issue's old URL, kept for shared links. The loader always
 * redirects to `/market/newsletters/$issueNumber` with the same raw param (the reader refuses a
 * bad one itself, without asking the network), so `component` never renders on a real visit.
 */
export const Route = createFileRoute('/_app/newsletters/$issueNumber')({
  loader: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/market/newsletters/$issueNumber',
      params: { issueNumber: params.issueNumber },
      replace: true,
    })
  },
  component: () => null,
})
